import React, { useRef } from 'react';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { ProductCard } from './ProductCard';
import type { Product } from '../types/shop';
type ProductCarouselProps = {
  products: Product[];
  label: string;
};
export function ProductCarousel({
  products,
  label
}: ProductCarouselProps) {
  const trackRef = useRef<HTMLUListElement>(null);
  function scroll(dir: 1 | -1) {
    const el = trackRef.current;
    if (!el) return;
    el.scrollBy({
      left: dir * el.clientWidth * 0.8,
      behavior: 'smooth'
    });
  }
  return <div data-id="element-356" data-mp="9dftfhu9qfac">
      <div className="mb-6 flex justify-end gap-2" data-id="element-357" data-mp="9atjjbjwnnoy">
        <button type="button" onClick={() => scroll(-1)} aria-label="Previous products" className="grid h-11 w-11 place-items-center border border-[#8F877F] text-charcoal transition-colors duration-150 hover:border-charcoal hover:bg-charcoal hover:text-white" data-id="element-358" data-mp="ddq61dckg3y6">
          <ArrowLeftIcon aria-hidden="true" strokeWidth={1.25} className="h-4 w-4" data-id="element-359" data-mp="3lukz613ka9z2" />
        </button>
        <button type="button" onClick={() => scroll(1)} aria-label="Next products" className="grid h-11 w-11 place-items-center border border-[#8F877F] text-charcoal transition-colors duration-150 hover:border-charcoal hover:bg-charcoal hover:text-white" data-id="element-360" data-mp="37a8of8nbc1ky">
          <ArrowRightIcon aria-hidden="true" strokeWidth={1.25} className="h-4 w-4" data-id="element-361" data-mp="2xium6t3z8no4" />
        </button>
      </div>
      <ul ref={trackRef} aria-label={label} className="no-scrollbar -mx-[var(--gutter)] flex snap-x snap-mandatory gap-[clamp(1rem,1.6vw,2rem)] overflow-x-auto scroll-px-[var(--gutter)] px-[var(--gutter)] pb-2" data-id="element-362" data-mp="2sj88yjo5f7fb">
        {products.map(p => <li key={p.id} className="w-[clamp(15rem,23vw,32rem)] shrink-0 snap-start" data-id="element-363" data-mp="2emcozw6czvkh">
            <ProductCard product={p} data-id="element-364" data-mp="29ni4mpsqtyy9" />
          </li>)}
      </ul>
    </div>;
}